import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";

type ConfirmActionDialogProps = {
  open: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onClose: () => void;
};

const ConfirmActionDialog: React.FC<ConfirmActionDialogProps> = ({
  open,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          background: "linear-gradient(180deg, rgba(16,18,24,0.98) 0%, rgba(10,12,18,0.98) 100%)",
          border: "1px solid rgba(255,255,255,0.16)",
          borderRadius: "14px",
          width: "100%",
          maxWidth: "460px",
          color: "#fff",
          boxShadow: "0 20px 50px rgba(0,0,0,0.52)",
        },
      }}
    >
      <DialogTitle
        sx={{
          py: 1.8,
          px: 2.2,
          borderBottom: "1px solid rgba(255,255,255,0.12)",
          color: "#fff",
          fontWeight: 700,
          fontSize: "1.1rem",
        }}
      >
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 10, top: 10, color: "rgba(255,255,255,0.8)" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 2.2, pt: 2.2, pb: 1.2 }}>
        <Typography sx={{ color: "rgba(255,255,255,0.86)", fontSize: "1rem", lineHeight: 1.5 }}>
          {message}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 2.2, pb: 2.2, pt: 1.2, gap: 1 }}>
        <Box sx={{ ml: "auto", display: "flex", gap: 1 }}>
          <Button
            onClick={onClose}
            sx={{
              color: "#fff",
              border: "1px solid rgba(255,255,255,0.22)",
              background: "rgba(255,255,255,0.06)",
              minWidth: 98,
              "&:hover": {
                background: "rgba(255,255,255,0.11)",
              },
            }}
          >
            {cancelText}
          </Button>
          <Button
            onClick={onConfirm}
            sx={{
              color: "#111",
              fontWeight: 700,
              minWidth: 98,
              background: "linear-gradient(90deg, #FF8D1E 0%, #FF4D7D 100%)",
              "&:hover": {
                background: "linear-gradient(90deg, #ff9a3c 0%, #ff5f8e 100%)",
              },
            }}
          >
            {confirmText}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmActionDialog;
